import React from 'react';
// import Dialog from 'material-ui/Dialog';
// import CircularProgress from 'material-ui/CircularProgress';
// import AutoComplete from 'material-ui/AutoComplete';
// import MenuItem from 'material-ui/MenuItem';
import StatsTable from 'components/lib/tables/StatsTable';
import styles from 'styles/components/series/SeriesSummary.css';
// import clear_icon from 'images/icons/clearText_icon.png';

const SeriesSummary = (props) => {
  let stats = [
    {alt: "Since first ticket sold", label: "Days On Sale", value: props.daysOnSale },
    {alt: "Until last event in series", label: "Remaining Days", value: props.remainingDays },
    {alt: "Private section tickets included. Comped and package tickets not included. Total Revenue: $" + props.totalTicketRevenueSansPackages, label: "Total Tickets Sold", value: props.totalTicketsSold },
    {alt: "Total Sales Revenue (Not Including Packages) / Total Tickets Sold", label: "Average Ticket Price", value: (props.totalTicketRevenueSansPackages / props.totalTicketsSold) },
    {alt: "For upcoming events (includes private sections)", label: "Total Series Holds", value: props.totalSeriesHolds },
    {alt: "For upcoming events", label: "Total Seats Available", value: props.totalSeatsAvailable },
    {alt: "Package Tickets Only", label: "Package Tickets", value: props.totalPackageTickets },
    {alt: "Not included in Total Tickets Sold", label: "Total Comps", value: props.totalComps }
  ];
  return (
    <div className={styles.seriesSummary}>
      <StatsTable
        className={styles.seriesStats}
        stats={stats}
        title="Key Stats"
        tooltipPlacement="bottom"
        handleTooltip={ props.handleTooltip } />
    </div>
  );
};

SeriesSummary.defaultProps = {
  daysOnSale: "-",
  remainingDays: "-",
  totalTicketsSold: "-",
  totalSeriesHolds: "-",
  totalSeatsAvailable: "-",
  totalPackageTickets: "-",
  totalComps: "-",
  seriesAutoCompleteText: "-"
};

export default SeriesSummary;



// WEBPACK FOOTER //
// ./src/scripts/components/series/SeriesSummary.js